import { DynamicModal } from "src/components/base/components/DynamicModal";
import { createState } from "src/utils/create_zustand_store";
import { useRouterExt } from "../../hooks/useRouterExt";
import { routes } from "src/shared/routes";
import { TmAccountDetails } from "../TmAccountDetails";
import { Box } from "@mui/material";
import React from "react";
import { useGroupInviteFlow } from "src/components/feature/groupInviteFlow/useGroupInviteFlow";
import { useGlobalStore } from "../../hooks/useGlobalStore";

export const useAnotherGroupWarningModal = createState({
  isOpen: false,
});

export function AnotherGroupWarningModal() {
  const router = useRouterExt();
  const modalState = useAnotherGroupWarningModal();
  const [isConfirming, setIsConfirming] = React.useState(false);
  const { handleLeaveAndJoinGroup, groupLeader } = useGroupInviteFlow();

  const onClose = () => {
    router.pushSchema(routes.my_group);
    modalState.reset();
  };

  return (
    <DynamicModal
      isOpen={modalState.isOpen}
      title="Join Another Group?"
      description={
        <Box py={1}>
          You are already a member of a group. By accepting this invite you will
          leave your current group and join{" "}
          <b>
            {groupLeader?.firstName} {groupLeader?.lastName}
          </b>
          &apos;s group.
        </Box>
      }
      onClose={onClose}
      slot={{
        primaryButton: {
          label: "Join Group",
          isLoading: isConfirming,
          isDisabled: isConfirming,
          onClick: async () => {
            setIsConfirming(true);
            await handleLeaveAndJoinGroup();
            await router.pushSchema(routes.my_group);
            setIsConfirming(false);
            onClose();
          },
        },
        secondaryButton: {
          label: "Cancel",
          onClick: () => onClose(),
        },
      }}
    />
  );
}
